export default __webpack_public_path__ + "static/media/928.895322e5.png";